"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ptypes_filter = void 0;
var ptypes_filter = [{
  "id": 0,
  "key": "all",
  "keys": ["all", "tutte", "tutte"],
  "slug": {
    "it": "tutte"
  },
  "label": {
    "it": "tutte"
  },
  "order": 0,
  "label_plural": {
    "it": "tutte"
  },
  "children": [],
  "has_children": 0
}, {
  "id": 5,
  "key": "residenziale",
  "keys": ["residenziale", "residenziale", "residenziale"],
  "slug": {
    "it": "residenziale"
  },
  "label": {
    "it": "residenziale"
  },
  "order": 0,
  "label_plural": {
    "it": "residenziale"
  },
  "children": [{
    "id": 1,
    "key": "all",
    "keys": ["all", "Tutte", "tutte"],
    "slug": {
      "it": "tutte"
    },
    "label": {
      "it": "Tutte"
    },
    "order": 0,
    "label_plural": {
      "it": "Tutte"
    },
    "category": "residenziale"
  }, {
    "id": 1,
    "key": "Appartamento",
    "keys": ["Appartamento", "Appartamento", "appartamento"],
    "keysFor301": ["monolocale", "monolocali"],
    "slug": {
      "it": "appartamento"
    },
    "label": {
      "it": "Appartamento"
    },
    "order": 0,
    "label_plural": {
      "it": "Appartamento"
    },
    "category": "residenziale"
  }, {
    "id": 1,
    "key": "Attico/mansarda",
    "keys": ["Attico", "attico", "Mansarda", "mansarda", "Attico/Mansarda", "Attico/mansarda", "attico/mansarda", "Attico / Mansarda", "attico / mansarda", "Attico+Mansarda", "attico+mansarda", "Attico-Mansarda", "attico-mansarda"],
    "keysFor301": ["attico", "attici", "mansarda", "mansarde"],
    "slug": {
      "it": "attico+mansarda"
    },
    "label": {
      "it": "Attico/mansarda"
    },
    "order": 0,
    "label_plural": {
      "it": "Attici/mansarde"
    },
    "category": "residenziale"
  }, {
    "id": 1,
    "key": "Baita/chalet/trullo",
    "keys": ["Baita/Chalet/Trullo", "Baita/chalet/trullo", "baita+chalet+trullo"],
    "slug": {
      "it": "baita+chalet+trullo"
    },
    "label": {
      "it": "Baita/chalet/trullo"
    },
    "order": 0,
    "label_plural": {
      "it": "Baite/chalet/trulli"
    },
    "category": "residenziale"
  }, {
    "id": 1,
    "key": "Baita/bungalow/chalet/trullo",
    "keys": ["Baita/bungalow/chalet/Trullo", "Baita/Bungalow/Chalet/Trullo", "baita+bungalow+chalet+trullo"],
    "slug": {
      "it": "baita+bungalow+chalet+trullo"
    },
    "label": {
      "it": "Baita/bungalow/chalet/trullo"
    },
    "order": 0,
    "label_plural": {
      "it": "Baite/bungalow/chalet/trulli"
    },
    "category": "residenziale"
  }, {
    "id": 1,
    "key": "Bungalow",
    "keys": ["Bungalow", "Bungalow", "bungalow"],
    "slug": {
      "it": "bungalow"
    },
    "label": {
      "it": "Bungalow"
    },
    "order": 0,
    "label_plural": {
      "it": "Bungalow"
    },
    "category": "residenziale"
  }, {
    "id": 1,
    "key": "Casa bi/trifamiliare",
    "keys": ["Casa bi/trifamiliare", "Casa bi/trifamiliare", "casa+bi+trifamiliare"],
    "slug": {
      "it": "casa+bi+trifamiliare"
    },
    "label": {
      "it": "Casa bi/trifamiliare"
    },
    "order": 0,
    "label_plural": {
      "it": "Case bi/trifamiliari"
    },
    "category": "residenziale"
  }, {
    "id": 1,
    "key": "Casa indipendente",
    "keys": ["Casa indipendente", "Casa indipendente", "casa+indipendente"],
    "slug": {
      "it": "casa+indipendente"
    },
    "label": {
      "it": "Casa indipendente"
    },
    "order": 0,
    "label_plural": {
      "it": "Casa indipendente"
    },
    "category": "residenziale"
  }, {
    "id": 1,
    "key": "Garage/box auto",
    "keys": ["Garage/Box auto", "Garage/box auto", "garage+box+auto"],
    "slug": {
      "it": "garage+box+auto"
    },
    "label": {
      "it": "Garage/box auto"
    },
    "order": 0,
    "label_plural": {
      "it": "Garage/box auto"
    },
    "category": "residenziale"
  }, {
    "id": 1,
    "key": "Immobile di prestigio",
    "keys": ["Immobile di prestigio", "Immobile di prestigio", "immobile+di+prestigio"],
    "slug": {
      "it": "immobile+di+prestigio"
    },
    "label": {
      "it": "Immobile di prestigio"
    },
    "order": 0,
    "label_plural": {
      "it": "Immobile di prestigio"
    },
    "category": "residenziale"
  }, {
    "id": 1,
    "key": "Loft",
    "keys": ["Loft", "Loft", "loft"],
    "slug": {
      "it": "loft"
    },
    "label": {
      "it": "Loft"
    },
    "order": 0,
    "label_plural": {
      "it": "Loft"
    },
    "category": "residenziale"
  }, {
    "id": 1,
    "key": "Palazzo",
    "keys": ["Palazzo", "Palazzo", "palazzo"],
    "slug": {
      "it": "palazzo"
    },
    "label": {
      "it": "Palazzo"
    },
    "order": 0,
    "label_plural": {
      "it": "Palazzo"
    },
    "category": "residenziale"
  }, {
    "id": 1,
    "key": "Porzione di casa",
    "keys": ["Porzione di casa", "Porzione di casa", "porzione+di+casa"],
    "slug": {
      "it": "porzione+di+casa"
    },
    "label": {
      "it": "Porzione di casa"
    },
    "order": 0,
    "label_plural": {
      "it": "Porzione di casa"
    },
    "category": "residenziale"
  }, {
    "id": 1,
    "key": "Rustico/casale",
    "keys": ["Rustico/casale", "Rustico/Casale", "rustico+casale"],
    "slug": {
      "it": "rustico+casale"
    },
    "label": {
      "it": "Rustico/casale"
    },
    "order": 0,
    "label_plural": {
      "it": "Rustici/casali"
    },
    "category": "residenziale"
  }, {
    "id": 1,
    "key": "Stanza",
    "keys": ["Stanza", "Stanza", "stanza"],
    "slug": {
      "it": "stanza"
    },
    "label": {
      "it": "Stanza"
    },
    "order": 0,
    "label_plural": {
      "it": "Stanze"
    },
    "category": "residenziale"
  }, {
    "id": 1,
    "key": "Villa",
    "keys": ["Villa", "Villa", "villa"],
    "slug": {
      "it": "villa"
    },
    "label": {
      "it": "Villa"
    },
    "order": 0,
    "label_plural": {
      "it": "Villa"
    },
    "category": "residenziale"
  }, {
    "id": 1,
    "key": "Villetta a schiera",
    "keys": ["Villetta a schiera", "Villetta a schiera", "villetta+a+schiera"],
    "slug": {
      "it": "villetta+a+schiera"
    },
    "label": {
      "it": "Villetta a schiera"
    },
    "order": 0,
    "label_plural": {
      "it": "Villetta a schiera"
    },
    "category": "residenziale"
  }],
  "has_children": 1
}, {
  "id": 15,
  "key": "vacanze",
  "keys": ["vacanze", "vacanze", "vacanze"],
  "slug": {
    "it": "vacanze"
  },
  "label": {
    "it": "vacanze"
  },
  "order": 0,
  "label_plural": {
    "it": "vacanze"
  },
  "children": [{
    "id": 1,
    "key": "all",
    "keys": ["all", "Tutte", "tutte"],
    "slug": {
      "it": "tutte"
    },
    "label": {
      "it": "Tutte"
    },
    "order": 0,
    "label_plural": {
      "it": "Tutte"
    },
    "category": "vacanze"
  }, {
    "id": 1,
    "key": "Appartamento",
    "keys": ["Appartamento", "Appartamento", "appartamento"],
    "keysFor301": ["monolocale", "monolocali"],
    "slug": {
      "it": "appartamento"
    },
    "label": {
      "it": "Appartamento"
    },
    "order": 0,
    "label_plural": {
      "it": "Appartamento"
    },
    "category": "vacanze"
  }, {
    "id": 1,
    "key": "Attico/mansarda",
    "keys": ["Attico", "attico", "Mansarda", "mansarda", "Attico/Mansarda", "Attico/mansarda", "attico/mansarda", "Attico / Mansarda", "Attico / mansarda", "attico / mansarda", "Attico+Mansarda", "attico+mansarda", "Attico-Mansarda", "attico-mansarda"],
    "keysFor301": ["attico", "attici", "mansarda", "mansarde"],
    "slug": {
      "it": "attico+mansarda"
    },
    "label": {
      "it": "Attico/mansarda"
    },
    "order": 0,
    "label_plural": {
      "it": "Attici/mansarde"
    },
    "category": "vacanze"
  }, {
    "id": 1,
    "key": "Baita/chalet/trullo",
    "keys": ["Baita/chalet/trullo", "Baita/Chalet/Trullo", "baita+chalet+trullo"],
    "slug": {
      "it": "baita+chalet+trullo"
    },
    "label": {
      "it": "Baita/chalet/trullo"
    },
    "order": 0,
    "label_plural": {
      "it": "Baite/chalet/trulli"
    },
    "category": "vacanze"
  }, {
    "id": 1,
    "key": "Baita/bungalow/chalet/trullo",
    "keys": ["Baita/bungalow/chalet/trullo", "Baita/Bungalow/Chalet/Trullo", "baita+chalet+trullo"],
    "slug": {
      "it": "baita+bungalow+chalet+trullo"
    },
    "label": {
      "it": "Baita/bungalow/chalet/trullo"
    },
    "order": 0,
    "label_plural": {
      "it": "Baite/bungalow/chalet/trulli"
    },
    "category": "vacanze"
  }, {
    "id": 1,
    "key": "Bungalow",
    "keys": ["Bungalow", "Bungalow", "bungalow"],
    "slug": {
      "it": "bungalow"
    },
    "label": {
      "it": "Bungalow"
    },
    "order": 0,
    "label_plural": {
      "it": "Bungalow"
    },
    "category": "vacanze"
  }, {
    "id": 1,
    "key": "Cantina/solaio",
    "keys": ["Cantina/solaio", "Cantina/Solaio", "cantina+solaio", "cantina+solaio"],
    "slug": {
      "it": "cantina+solaio"
    },
    "label": {
      "it": "Cantina/solaio"
    },
    "order": 0,
    "label_plural": {
      "it": "Cantine/solai"
    },
    "category": "vacanze"
  }, {
    "id": 1,
    "key": "Casa bi/trifamiliare",
    "keys": ["Casa bi/trifamiliare", "Casa bi/trifamiliare", "casa+bi+trifamiliare"],
    "slug": {
      "it": "casa+bi+trifamiliare"
    },
    "label": {
      "it": "Casa bi/trifamiliare"
    },
    "order": 0,
    "label_plural": {
      "it": "Casa bi/trifamiliare"
    },
    "category": "vacanze"
  }, {
    "id": 1,
    "key": "Casa indipendente",
    "keys": ["Casa indipendente", "Casa indipendente", "casa+indipendente"],
    "slug": {
      "it": "casa+indipendente"
    },
    "label": {
      "it": "Casa indipendente"
    },
    "order": 0,
    "label_plural": {
      "it": "Casa indipendente"
    },
    "category": "vacanze"
  }, {
    "id": 1,
    "key": "Garage/box auto",
    "keys": ["Garage/box auto", "Garage/Box auto", "garage+box+auto"],
    "slug": {
      "it": "garage+box+auto"
    },
    "label": {
      "it": "Garage/box auto"
    },
    "order": 0,
    "label_plural": {
      "it": "Garage/box auto"
    },
    "category": "vacanze"
  }, {
    "id": 1,
    "key": "Immobile di prestigio",
    "keys": ["Immobile di prestigio", "Immobile di prestigio", "immobile+di+prestigio"],
    "slug": {
      "it": "immobile+di+prestigio"
    },
    "label": {
      "it": "Immobile di prestigio"
    },
    "order": 0,
    "label_plural": {
      "it": "Immobile di prestigio"
    },
    "category": "vacanze"
  }, {
    "id": 1,
    "key": "Loft",
    "keys": ["Loft", "Loft", "loft"],
    "slug": {
      "it": "loft"
    },
    "label": {
      "it": "Loft"
    },
    "order": 0,
    "label_plural": {
      "it": "Loft"
    },
    "category": "vacanze"
  }, {
    "id": 1,
    "key": "Palazzo",
    "keys": ["Palazzo", "Palazzo", "palazzo"],
    "slug": {
      "it": "palazzo"
    },
    "label": {
      "it": "Palazzo"
    },
    "order": 0,
    "label_plural": {
      "it": "Palazzo"
    },
    "category": "vacanze"
  }, {
    "id": 1,
    "key": "Porzione di casa",
    "keys": ["Porzione di casa", "Porzione di casa", "porzione+di+casa"],
    "slug": {
      "it": "porzione+di+casa"
    },
    "label": {
      "it": "Porzione di casa"
    },
    "order": 0,
    "label_plural": {
      "it": "Porzione di casa"
    },
    "category": "vacanze"
  }, {
    "id": 1,
    "key": "Rustico/casale",
    "keys": ["Rustico/casale", "Rustico/Casale", "rustico+casale"],
    "slug": {
      "it": "rustico+casale"
    },
    "label": {
      "it": "Rustico/casale"
    },
    "order": 0,
    "label_plural": {
      "it": "Rustico/casale"
    },
    "category": "vacanze"
  }, {
    "id": 1,
    "key": "Villa",
    "keys": ["Villa", "Villa", "villa"],
    "slug": {
      "it": "villa"
    },
    "label": {
      "it": "Villa"
    },
    "order": 0,
    "label_plural": {
      "it": "Villa"
    },
    "category": "vacanze"
  }, {
    "id": 1,
    "key": "Villetta a schiera",
    "keys": ["Villetta a schiera", "Villetta a schiera", "villetta+a+schiera"],
    "slug": {
      "it": "villetta+a+schiera"
    },
    "label": {
      "it": "Villetta a schiera"
    },
    "order": 0,
    "label_plural": {
      "it": "Villetta a schiera"
    },
    "category": "vacanze"
  }, {
    "id": 1,
    "key": "Terreno",
    "keys": ["Terreno", "Terreno", "terreno"],
    "slug": {
      "it": "terreno"
    },
    "label": {
      "it": "Terreno"
    },
    "order": 0,
    "label_plural": {
      "it": "Terreno"
    },
    "category": "vacanze"
  }, {
    "id": 1,
    "key": "Terreno edificabile",
    "keys": ["Terreno edificabile", "Terreno edificabile", "terreno+edificabile"],
    "slug": {
      "it": "terreno+edificabile"
    },
    "label": {
      "it": "Terreno edificabile"
    },
    "order": 0,
    "label_plural": {
      "it": "Terreno edificabile"
    },
    "category": "vacanze"
  }],
  "has_children": 1
}, {
  "id": 5,
  "key": "case",
  "keys": ["case", "case", "case"],
  "slug": {
    "it": "case"
  },
  "label": {
    "it": "case"
  },
  "order": 0,
  "label_plural": {
    "it": "case"
  },
  "children": [{
    "id": 1,
    "key": "all",
    "keys": ["all", "Tutte", "tutte"],
    "slug": {
      "it": "tutte"
    },
    "label": {
      "it": "Tutte"
    },
    "order": 0,
    "label_plural": {
      "it": "Tutte"
    },
    "category": "case"
  }, {
    "id": 1,
    "key": "Appartamento",
    "keys": ["Appartamento", "Appartamento", "appartamento"],
    "keysFor301": ["monolocale", "monolocali"],
    "slug": {
      "it": "appartamento"
    },
    "label": {
      "it": "Appartamento"
    },
    "order": 0,
    "label_plural": {
      "it": "Appartamento"
    },
    "category": "case"
  }, {
    "id": 1,
    "key": "Attico/mansarda",
    "keys": ["Attico", "attico", "Mansarda", "mansarda", "Attico/mansarda", "Attico/Mansarda", "attico/mansarda", "Attico / Mansarda", "Attico / mansarda", "attico / mansarda", "Attico+Mansarda", "attico+mansarda", "Attico-Mansarda", "attico-mansarda"],
    "keysFor301": ["attico", "attici", "mansarda", "mansarde"],
    "slug": {
      "it": "attico+mansarda"
    },
    "label": {
      "it": "Attico/mansarda"
    },
    "order": 0,
    "label_plural": {
      "it": "Attici/mansarde"
    },
    "category": "case"
  }, {
    "id": 1,
    "key": "Baita/chalet/trullo",
    "keys": ["Baita/chalet/trullo", "Baita/Chalet/Trullo", "baita+chalet+trullo"],
    "slug": {
      "it": "baita+chalet+trullo"
    },
    "label": {
      "it": "Baita/chalet/trullo"
    },
    "order": 0,
    "label_plural": {
      "it": "Baite/chalet/trulli"
    },
    "category": "case"
  }, {
    "id": 1,
    "key": "Baita/bungalow/chalet/trullo",
    "keys": ["Baita/bungalow/chalet/trullo", "Baita/Bungalow/Chalet/Trullo", "baita+bungalow+chalet+trullo"],
    "slug": {
      "it": "baita+bungalow+chalet+trullo"
    },
    "label": {
      "it": "Baita/bungalow/chalet/trullo"
    },
    "order": 0,
    "label_plural": {
      "it": "Baite/bungalow/chalet/trulli"
    },
    "category": "case"
  }, {
    "id": 1,
    "key": "Bungalow",
    "keys": ["Bungalow", "Bungalow", "bungalow"],
    "slug": {
      "it": "bungalow"
    },
    "label": {
      "it": "Bungalow"
    },
    "order": 0,
    "label_plural": {
      "it": "Bungalow"
    },
    "category": "case"
  }, {
    "id": 1,
    "key": "Casa bi/trifamiliare",
    "keys": ["Casa bi/trifamiliare", "Casa bi/trifamiliare", "casa+bi+trifamiliare"],
    "slug": {
      "it": "casa+bi+trifamiliare"
    },
    "label": {
      "it": "Casa bi/trifamiliare"
    },
    "order": 0,
    "label_plural": {
      "it": "Casa bi/trifamiliare"
    },
    "category": "case"
  }, {
    "id": 1,
    "key": "Casa indipendente",
    "keys": ["Casa indipendente", "Casa indipendente", "casa+indipendente"],
    "slug": {
      "it": "casa+indipendente"
    },
    "label": {
      "it": "Casa indipendente"
    },
    "order": 0,
    "label_plural": {
      "it": "Casa indipendente"
    },
    "category": "case"
  }, {
    "id": 1,
    "key": "Garage/box auto",
    "keys": ["Garage/box auto", "Garage/Box auto", "garage+box+auto"],
    "slug": {
      "it": "garage+box+auto"
    },
    "label": {
      "it": "Garage/box auto"
    },
    "order": 0,
    "label_plural": {
      "it": "Garage/box auto"
    },
    "category": "case"
  }, {
    "id": 1,
    "key": "Immobile di prestigio",
    "keys": ["Immobile di prestigio", "Immobile di prestigio", "immobile+di+prestigio"],
    "slug": {
      "it": "immobile+di+prestigio"
    },
    "label": {
      "it": "Immobile di prestigio"
    },
    "order": 0,
    "label_plural": {
      "it": "Immobile di prestigio"
    },
    "category": "case"
  }, {
    "id": 1,
    "key": "Loft",
    "keys": ["Loft", "Loft", "loft"],
    "slug": {
      "it": "loft"
    },
    "label": {
      "it": "Loft"
    },
    "order": 0,
    "label_plural": {
      "it": "Loft"
    },
    "category": "case"
  }, {
    "id": 1,
    "key": "Palazzo",
    "keys": ["Palazzo", "Palazzo", "palazzo"],
    "slug": {
      "it": "palazzo"
    },
    "label": {
      "it": "Palazzo"
    },
    "order": 0,
    "label_plural": {
      "it": "Palazzo"
    },
    "category": "case"
  }, {
    "id": 1,
    "key": "Porzione di casa",
    "keys": ["Porzione di casa", "Porzione di casa", "porzione+di+casa"],
    "slug": {
      "it": "porzione+di+casa"
    },
    "label": {
      "it": "Porzione di casa"
    },
    "order": 0,
    "label_plural": {
      "it": "Porzione di casa"
    },
    "category": "case"
  }, {
    "id": 1,
    "key": "Rustico/casale",
    "keys": ["Rustico/casale", "Rustico/Casale", "rustico+casale"],
    "slug": {
      "it": "rustico+casale"
    },
    "label": {
      "it": "Rustico/casale"
    },
    "order": 0,
    "label_plural": {
      "it": "Rustico/casale"
    },
    "category": "case"
  }, {
    "id": 1,
    "key": "Villa",
    "keys": ["Villa", "Villa", "villa"],
    "slug": {
      "it": "villa"
    },
    "label": {
      "it": "Villa"
    },
    "order": 0,
    "label_plural": {
      "it": "Villa"
    },
    "category": "case"
  }, {
    "id": 1,
    "key": "Villetta a schiera",
    "keys": ["Villetta a schiera", "Villetta a schiera", "villetta+a+schiera"],
    "slug": {
      "it": "villetta+a+schiera"
    },
    "label": {
      "it": "Villetta a schiera"
    },
    "order": 0,
    "label_plural": {
      "it": "Villetta a schiera"
    },
    "category": "case"
  }],
  "has_children": 1
}, {
  "id": 10,
  "key": "commerciale",
  "keys": ["commerciale", "commerciale", "commerciale"],
  "slug": {
    "it": "commerciale"
  },
  "label": {
    "it": "commerciale"
  },
  "order": 0,
  "label_plural": {
    "it": "commerciale"
  },
  "children": [{
    "id": 1,
    "key": "all",
    "keys": ["all", "Tutte", "tutte"],
    "slug": {
      "it": "tutte"
    },
    "label": {
      "it": "Tutte"
    },
    "order": 0,
    "label_plural": {
      "it": "Tutte"
    },
    "category": "commerciale"
  }, {
    "id": 1,
    "key": "Albergo",
    "keys": ["Albergo", "Albergo", "albergo"],
    "slug": {
      "it": "albergo"
    },
    "label": {
      "it": "Albergo"
    },
    "order": 0,
    "label_plural": {
      "it": "Albergo"
    },
    "category": "commerciale"
  }, {
    "id": 1,
    "key": "Azienda agricola",
    "keys": ["Azienda agricola", "Azienda agricola", "azienda+agricola"],
    "slug": {
      "it": "azienda+agricola"
    },
    "label": {
      "it": "Azienda agricola"
    },
    "order": 0,
    "label_plural": {
      "it": "Azienda agricola"
    },
    "category": "commerciale"
  }, {
    "id": 1,
    "key": "Bar",
    "keys": ["Bar", "Bar", "bar"],
    "slug": {
      "it": "bar"
    },
    "label": {
      "it": "Bar"
    },
    "order": 0,
    "label_plural": {
      "it": "Bar"
    },
    "category": "commerciale"
  }, // {
  //   "id": 1,
  //   "key": "Capannone",
  //   "keys": [
  //     "Capannone",
  //     "Capannone",
  //     "capannone"
  //   ],
  //   "slug": {
  //     "it": "capannone"
  //   },
  //   "label": {
  //     "it": "Capannone"
  //   },
  //   "order": 0,
  //   "label_plural": {
  //     "it": "Capannone"
  //   },
  //   "category": "commerciale"
  // },
  {
    "id": 1,
    "key": "Cessione di azienda",
    "keys": ["Cessione di azienda", "Cessione di azienda", "cessione+di+azienda"],
    "slug": {
      "it": "cessione+di+azienda"
    },
    "label": {
      "it": "Cessione di azienda"
    },
    "order": 0,
    "label_plural": {
      "it": "Cessione di azienda"
    },
    "category": "commerciale"
  }, {
    "id": 1,
    "key": "Garage/auto silos",
    "keys": ["Garage/auto silos", "Garage / auto silos", "Garage / Auto silos", "Garage/Auto silos", "garage+auto+silos", "garage+++auto+silos"],
    "slug": {
      "it": "garage+auto+silos"
    },
    "label": {
      "it": "Garage/auto silos"
    },
    "order": 0,
    "label_plural": {
      "it": "Garage/auto silos"
    },
    "category": "commerciale"
  }, {
    "id": 1,
    "key": "Immobile di prestigio",
    "keys": ["Immobile di prestigio", "Immobile di prestigio", "immobile+di+prestigio"],
    "slug": {
      "it": "immobile+di+prestigio"
    },
    "label": {
      "it": "Immobile di prestigio"
    },
    "order": 0,
    "label_plural": {
      "it": "Immobile di prestigio"
    },
    "category": "commerciale"
  }, // {
  //   "id": 1,
  //   "key": "Laboratorio",
  //   "keys": [
  //     "Laboratorio",
  //     "Laboratorio",
  //     "laboratorio"
  //   ],
  //   "slug": {
  //     "it": "laboratorio"
  //   },
  //   "label": {
  //     "it": "Laboratorio"
  //   },
  //   "order": 0,
  //   "label_plural": {
  //     "it": "Laboratorio"
  //   },
  //   "category": "commerciale"
  // },
  {
    "id": 1,
    "key": "Locale commerciale",
    "keys": ["Locale commerciale", "Locale commerciale", "locale+commerciale"],
    "slug": {
      "it": "locale+commerciale"
    },
    "label": {
      "it": "Locale commerciale"
    },
    "order": 0,
    "label_plural": {
      "it": "Locale commerciale"
    },
    "category": "commerciale"
  }, // {
  //   "id": 1,
  //   "key": "Negozio/Locale commerciale",
  //   "keys": [
  //     "Negozio/Locale commerciale",
  //     "Negozio Locale commerciale",
  //     "negozio+locale+commerciale",
  //     "negozio,locale+commerciale"
  //   ],
  //   "slug": {
  //     "it": "negozio+locale+commerciale"
  //   },
  //   "label": {
  //     "it": "Negozio/Locale commerciale"
  //   },
  //   "order": 0,
  //   "label_plural": {
  //     "it": "Negozio/Locale commerciale"
  //   },
  //   "category": "commerciale"
  // },
  {
    "id": 1,
    "key": "Magazzino",
    "keys": ["Magazzino", "Magazzino", "magazzino"],
    "slug": {
      "it": "magazzino"
    },
    "label": {
      "it": "Magazzino"
    },
    "order": 0,
    "label_plural": {
      "it": "Magazzino"
    },
    "category": "commerciale"
  }, // {
  //   "id": 1,
  //   "key": "Negozio",
  //   "keys": [
  //     "Negozio",
  //     "Negozio",
  //     "negozio"
  //   ],
  //   "slug": {
  //     "it": "negozio"
  //   },
  //   "label": {
  //     "it": "Negozio"
  //   },
  //   "order": 0,
  //   "label_plural": {
  //     "it": "Negozio"
  //   },
  //   "category": "commerciale"
  // },
  {
    "id": 1,
    "key": "Resort",
    "keys": ["Resort", "Resort", "resort"],
    "slug": {
      "it": "resort"
    },
    "label": {
      "it": "Resort"
    },
    "order": 0,
    "label_plural": {
      "it": "Resort"
    },
    "category": "commerciale"
  }, {
    "id": 1,
    "key": "Ristorante",
    "keys": ["Ristorante", "Ristorante", "ristorante"],
    "slug": {
      "it": "ristorante"
    },
    "label": {
      "it": "Ristorante"
    },
    "order": 0,
    "label_plural": {
      "it": "Ristorante"
    },
    "category": "commerciale"
  }, {
    "id": 1,
    "key": "Show room",
    "keys": ["Show room", "Show room", "show+room"],
    "slug": {
      "it": "show+room"
    },
    "label": {
      "it": "Show room"
    },
    "order": 0,
    "label_plural": {
      "it": "Show room"
    },
    "category": "commerciale"
  }, // {
  //   "id": 1,
  //   "key": "Stabile/Palazzo",
  //   "keys": [
  //     "Stabile / Palazzo",
  //     "Stabile/Palazzo",
  //     "stabile+palazzo",
  //     "stabile++palazzo",
  //     "palazzo"
  //   ],
  //   "slug": {
  //     "it": "stabile+palazzo"
  //   },
  //   "label": {
  //     "it": "Stabile/Palazzo"
  //   },
  //   "order": 0,
  //   "label_plural": {
  //     "it": "Stabile/Palazzo"
  //   },
  //   "category": "commerciale"
  // },
  // {
  //   "id": 1,
  //   "key": "Ufficio",
  //   "keys": [
  //     "Ufficio",
  //     "Ufficio",
  //     "ufficio"
  //   ],
  //   "slug": {
  //     "it": "ufficio"
  //   },
  //   "label": {
  //     "it": "Ufficio"
  //   },
  //   "order": 0,
  //   "label_plural": {
  //     "it": "Ufficio"
  //   },
  //   "category": "commerciale"
  // },
  {
    "id": 1,
    "key": "Ufficio di rappresentanza",
    "keys": ["Ufficio di rappresentanza", "Ufficio di rappresentanza", "ufficio+di+rappresentanza"],
    "slug": {
      "it": "ufficio+di+rappresentanza"
    },
    "label": {
      "it": "Ufficio di rappresentanza"
    },
    "order": 0,
    "label_plural": {
      "it": "Ufficio di rappresentanza"
    },
    "category": "commerciale"
  },
  /* TECH-7860 - TRASPASOS */
  {
    "id": 1,
    "key": "Negozio/locale commerciale",
    "keys": ["Negozio/Locale commerciale", "Negozio/locale commerciale", "negozio+locale+commerciale"],
    "slug": {
      "it": "negozio+locale+commerciale"
    },
    "label": {
      "it": "Negozio/locale commerciale"
    },
    "order": 0,
    "label_plural": {
      "it": "Negozi/locali commerciali"
    },
    "category": "commerciale"
  }, // {
  //   "id": 1,
  //   "key": "Immobile con attività commerciale",
  //   "keys": [
  //     "Immobile con attività commerciale",
  //     "immobile+con+attivita+commerciale"
  //   ],
  //   "slug": {
  //     "it": "immobile+con+attivita+commerciale"
  //   },
  //   "label": {
  //     "it": "Immobile con attività commerciale"
  //   },
  //   "order": 0,
  //   "label_plural": {
  //     "it": "Immobili con attività commerciali"
  //   },
  //   "category": "commerciale"
  // },
  {
    "id": 1,
    "key": "Attività/licenza (con o senza mura)",
    "keys": ["Attività/licenza (con o senza mura)", "Attività / licenza (con o senza mura)", "Attività/Licenza (con o senza mura)", "Attività / Licenza (con o senza mura)", "attivita+licenza+commerciale", "attivita-licenza-commerciale", "attivita+++licenza+commerciale"],
    "slug": {
      "it": "attivita+licenza+commerciale"
    },
    "label": {
      "it": "Attività/licenza commerciale"
    },
    "order": 0,
    "label_plural": {
      "it": "Attività/licenze commerciali"
    },
    "category": "commerciale"
  }
  /* TECH-7860 - TRASPASOS */
  ],
  "has_children": 1
}, {
  "id": 15,
  "key": "case-vacanza",
  "keys": ["case-vacanza", "case-vacanza", "case-vacanza"],
  "slug": {
    "it": "case-vacanza"
  },
  "label": {
    "it": "case-vacanza"
  },
  "order": 0,
  "label_plural": {
    "it": "case-vacanza"
  },
  "children": [{
    "id": 1,
    "key": "all",
    "keys": ["all", "Tutte", "tutte"],
    "slug": {
      "it": "tutte"
    },
    "label": {
      "it": "Tutte"
    },
    "order": 0,
    "label_plural": {
      "it": "Tutte"
    },
    "category": "case-vacanza"
  }, {
    "id": 1,
    "key": "Appartamento",
    "keys": ["Appartamento", "Appartamento", "appartamento"],
    "keysFor301": ["monolocale", "monolocali"],
    "slug": {
      "it": "appartamento"
    },
    "label": {
      "it": "Appartamento"
    },
    "order": 0,
    "label_plural": {
      "it": "Appartamento"
    },
    "category": "case-vacanza"
  }, {
    "id": 1,
    "key": "Attico/mansarda",
    "keys": ["Attico", "attico", "Mansarda", "mansarda", "Attico/mansarda", "Attico/Mansarda", "attico/mansarda", "Attico / mansarda", "Attico / Mansarda", "attico / mansarda", "Attico+Mansarda", "attico+mansarda", "Attico-Mansarda", "attico-mansarda"],
    "keysFor301": ["attico", "attici", "mansarda", "mansarde"],
    "slug": {
      "it": "attico+mansarda"
    },
    "label": {
      "it": "Attico/mansarda"
    },
    "order": 0,
    "label_plural": {
      "it": "Attici/mansarde"
    },
    "category": "case-vacanza"
  }, {
    "id": 1,
    "key": "Baita/chalet/trullo",
    "keys": ["Baita/chalet/trullo", "Baita/Chalet/Trullo", "baita+chalet+trullo"],
    "slug": {
      "it": "baita+chalet+trullo"
    },
    "label": {
      "it": "Baita/chalet/trullo"
    },
    "order": 0,
    "label_plural": {
      "it": "Baite/chalet/trulli"
    },
    "category": "case-vacanza"
  }, {
    "id": 1,
    "key": "Baita/bungalow/chalet/trullo",
    "keys": ["Baita/bungalow/chalet/trullo", "Baita/Bungalow/Chalet/Trullo", "baita+chalet+trullo"],
    "slug": {
      "it": "baita+bungalow+chalet+trullo"
    },
    "label": {
      "it": "Baita/bungalow/chalet/trullo"
    },
    "order": 0,
    "label_plural": {
      "it": "Baite/bungalow/chalet/trulli"
    },
    "category": "case-vacanza"
  }, {
    "id": 1,
    "key": "Bungalow",
    "keys": ["Bungalow", "Bungalow", "bungalow"],
    "slug": {
      "it": "bungalow"
    },
    "label": {
      "it": "Bungalow"
    },
    "order": 0,
    "label_plural": {
      "it": "Bungalow"
    },
    "category": "case-vacanza"
  }, {
    "id": 1,
    "key": "Cantina/solaio",
    "keys": ["Cantina/solaio", "Cantina/Solaio", "cantina+solaio", "cantine+solai"],
    "slug": {
      "it": "cantina+solaio"
    },
    "label": {
      "it": "Cantina/solaio"
    },
    "order": 0,
    "label_plural": {
      "it": "Cantine/solai"
    },
    "category": "case-vacanza"
  }, {
    "id": 1,
    "key": "Casa bi/trifamiliare",
    "keys": ["Casa bi/trifamiliare", "Casa bi/trifamiliare", "casa+bi+trifamiliare"],
    "slug": {
      "it": "casa+bi+trifamiliare"
    },
    "label": {
      "it": "Casa bi/trifamiliare"
    },
    "order": 0,
    "label_plural": {
      "it": "Casa bi/trifamiliare"
    },
    "category": "case-vacanza"
  }, {
    "id": 1,
    "key": "Casa indipendente",
    "keys": ["Casa indipendente", "Casa indipendente", "casa+indipendente"],
    "slug": {
      "it": "casa+indipendente"
    },
    "label": {
      "it": "Casa indipendente"
    },
    "order": 0,
    "label_plural": {
      "it": "Casa indipendente"
    },
    "category": "case-vacanza"
  }, {
    "id": 1,
    "key": "Garage/box auto",
    "keys": ["Garage/box auto", "Garage/Box auto", "garage+box+auto"],
    "slug": {
      "it": "garage+box+auto"
    },
    "label": {
      "it": "Garage/box auto"
    },
    "order": 0,
    "label_plural": {
      "it": "Garage/box auto"
    },
    "category": "case-vacanza"
  }, {
    "id": 1,
    "key": "Immobile di prestigio",
    "keys": ["Immobile di prestigio", "Immobile di prestigio", "immobile+di+prestigio"],
    "slug": {
      "it": "immobile+di+prestigio"
    },
    "label": {
      "it": "Immobile di prestigio"
    },
    "order": 0,
    "label_plural": {
      "it": "Immobile di prestigio"
    },
    "category": "case-vacanza"
  }, {
    "id": 1,
    "key": "Loft",
    "keys": ["Loft", "Loft", "loft"],
    "slug": {
      "it": "loft"
    },
    "label": {
      "it": "Loft"
    },
    "order": 0,
    "label_plural": {
      "it": "Loft"
    },
    "category": "case-vacanza"
  }, {
    "id": 1,
    "key": "Palazzo",
    "keys": ["Palazzo", "Palazzo", "palazzo"],
    "slug": {
      "it": "palazzo"
    },
    "label": {
      "it": "Palazzo"
    },
    "order": 0,
    "label_plural": {
      "it": "Palazzo"
    },
    "category": "case-vacanza"
  }, {
    "id": 1,
    "key": "Porzione di casa",
    "keys": ["Porzione di casa", "Porzione di casa", "porzione+di+casa"],
    "slug": {
      "it": "porzione+di+casa"
    },
    "label": {
      "it": "Porzione di casa"
    },
    "order": 0,
    "label_plural": {
      "it": "Porzione di casa"
    },
    "category": "case-vacanza"
  }, {
    "id": 1,
    "key": "Rustico/casale",
    "keys": ["Rustico/casale", "Rustico/Casale", "rustico+casale"],
    "slug": {
      "it": "rustico+casale"
    },
    "label": {
      "it": "Rustico/casale"
    },
    "order": 0,
    "label_plural": {
      "it": "Rustici/casali"
    },
    "category": "case-vacanza"
  }, {
    "id": 1,
    "key": "Villa",
    "keys": ["Villa", "Villa", "villa"],
    "slug": {
      "it": "villa"
    },
    "label": {
      "it": "Villa"
    },
    "order": 0,
    "label_plural": {
      "it": "Villa"
    },
    "category": "case-vacanza"
  }, {
    "id": 1,
    "key": "Villetta a schiera",
    "keys": ["Villetta a schiera", "Villetta a schiera", "villetta+a+schiera"],
    "slug": {
      "it": "villetta+a+schiera"
    },
    "label": {
      "it": "Villetta a schiera"
    },
    "order": 0,
    "label_plural": {
      "it": "Villetta a schiera"
    },
    "category": "case-vacanza"
  }],
  "has_children": 1
}, {
  "id": 25,
  "key": "terreni",
  "keys": ["terreni", "terreni", "terreni"],
  "slug": {
    "it": "terreni"
  },
  "label": {
    "it": "terreni"
  },
  "order": 0,
  "label_plural": {
    "it": "terreni"
  },
  "children": [{
    "id": 1,
    "key": "all",
    "keys": ["all", "Tutte", "tutte"],
    "slug": {
      "it": "tutte"
    },
    "label": {
      "it": "Tutte"
    },
    "order": 0,
    "label_plural": {
      "it": "Tutte"
    },
    "category": "terreni"
  }, {
    "id": 1,
    "key": "Terreno edificabile",
    "keys": ["Terreno edificabile", "Terreno edificabile", "terreno+edificabile"],
    "slug": {
      "it": "terreno+edificabile"
    },
    "label": {
      "it": "Terreno edificabile"
    },
    "order": 0,
    "label_plural": {
      "it": "Terreno edificabile"
    },
    "category": "terreni"
  }, {
    "id": 1,
    "key": "Terreno agricolo",
    "keys": ["Terreno agricolo", "Terreno agricolo", "terreno+agricolo"],
    "slug": {
      "it": "terreno+agricolo"
    },
    "label": {
      "it": "Terreno agricolo"
    },
    "order": 0,
    "label_plural": {
      "it": "Terreno agricolo"
    },
    "category": "terreni"
  }, {
    "id": 1,
    "key": "Terreno industriale",
    "keys": ["Terreno industriale", "Terreno industriale", "terreno+industriale"],
    "slug": {
      "it": "terreno+industriale"
    },
    "label": {
      "it": "Terreno industriale"
    },
    "order": 0,
    "label_plural": {
      "it": "Terreno industriale"
    },
    "category": "terreni"
  }],
  "has_children": 1
}, {
  "id": 30,
  "key": "cantine-solai",
  "keys": ["cantine-solai", "cantine+solai"],
  "slug": {
    "it": "cantine-solai"
  },
  "label": {
    "it": "cantine-solai"
  },
  "order": 0,
  "label_plural": {
    "it": "cantine-solai"
  },
  "children": [{
    "id": 1,
    "key": "Cantina solaio",
    "keys": ["Cantina solaio", "Cantina Solaio", "cantina+solaio"],
    "slug": {
      "it": "cantina+solaio"
    },
    "label": {
      "it": "Cantina solaio"
    },
    "order": 0,
    "label_plural": {
      "it": "Cantine solai"
    },
    "category": "cantine-solai"
  }],
  "has_children": 1
}, {
  "id": 30,
  "key": "cantina-solaio",
  "keys": ["cantina-solaio", "cantina+solaio"],
  "slug": {
    "it": "cantina-solaio"
  },
  "label": {
    "it": "cantina-solaio"
  },
  "order": 0,
  "label_plural": {
    "it": "cantine-solai"
  },
  "children": [{
    "id": 1,
    "key": "Cantina solaio",
    "keys": ["Cantina solaio", "Cantina Solaio", "cantina+solaio"],
    "slug": {
      "it": "cantina+solaio"
    },
    "label": {
      "it": "Cantina solaio"
    },
    "order": 0,
    "label_plural": {
      "it": "Cantine solai"
    },
    "category": "cantine-solai"
  }],
  "has_children": 1
}, {
  "id": 30,
  "key": "garage-posti-auto",
  "keys": ["garage-posto-auto", "garage-posti-auto", "garage+posto+auto", "garage+posto+auto"],
  "slug": {
    "it": "garage-posti-auto"
  },
  "label": {
    "it": "garage-posti-auto"
  },
  "order": 0,
  "label_plural": {
    "it": "garage-posti-auto"
  },
  "children": [{
    "id": 1,
    "key": "Garage, posto auto",
    "keys": ["Garage, posto auto", "Garage, Posto Auto", "Garage, posti auto", "Garage, Posti Auto", "garage+posto+auto"],
    "slug": {
      "it": "garage+posto+auto"
    },
    "label": {
      "it": "Garage, posto auto"
    },
    "order": 0,
    "label_plural": {
      "it": "Garage, posti auto"
    },
    "category": "garage-posti-auto"
  }],
  "has_children": 1
}, {
  "id": 30,
  "key": "stanze",
  "keys": ["stanza", "stanze"],
  "slug": {
    "it": "stanze"
  },
  "label": {
    "it": "stanze"
  },
  "order": 0,
  "label_plural": {
    "it": "stanze"
  },
  "children": [{
    "id": 1,
    "key": "Stanza",
    "keys": ["Stanza", "Stanze", "stanze"],
    "slug": {
      "it": "stanza"
    },
    "label": {
      "it": "Stanza"
    },
    "order": 0,
    "label_plural": {
      "it": "Stanze"
    },
    "category": "stanze"
  }],
  "has_children": 1
}];
exports.ptypes_filter = ptypes_filter;